/**
 * Redact Supabase one-time auth tokens from any URL that leaves the browser
 * (Datadog RUM view/resource URLs, Logs `view.url`, PostHog/GA pageviews).
 *
 * The password-reset email links to /reset-password?token_hash=…, and the page
 * waits for a click before spending it, so the token is live while it sits in
 * the address bar. The page strips it on mount, but the navigation
 * PerformanceEntry and the first log lines still see the original address.
 */
const AUTH_TOKEN_PARAM = /\b(token_hash|access_token|refresh_token)=[^&#]*/g;

export const scrubAuthTokensFromUrl = (rawUrl: string): string => {
  if (!rawUrl || !/(token_hash|access_token|refresh_token)=/.test(rawUrl)) return rawUrl;
  return rawUrl.replace(AUTH_TOKEN_PARAM, '$1=REDACTED');
};
